/**START NEW THE PROGRAM**/
function getPrograms() {
  var Pageurl = '/pages/the-program-programmi-personalizzati';
  if (window.location.href.includes(Pageurl) || window.location.href.includes('/pages/i-tuoi-the-program') && workoutConfig) {
    const subscriptionEl = $("#subscription");
    const oneshotEl = $("#oneshot");
    //Template
    const elItemO = '<div class="bff-subscription-container mb-30" height: 250px; width: 100%; max-width: 420px; margin: 0 auto;"></div>';
    const elHeadO = '<div class="bff-tp-detail-head"></div>';
    var settings = {
      "url": "https://backend-main-zu9ki2.laravel.cloud/api/shopify/show_tp",
      "method": "POST",
      "timeout": 0,
      "contentType":"application/json",
      "headers": {
        "Accept": "application/json",
        "Authorization": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxOSIsImp0aSI6IjE5N2I2OTg3OTY3ZjNlYWQ0YTdjMGFkMTIzMzJjMmFkMzJmZDUxMmQzNWI4ODg5MTAzNTE2ODU3NWIzY2YwZmExYWE2YWQxODU3NzliNjMwIiwiaWF0IjoxNzcwOTgwMjIxLjMxNDkzOCwibmJmIjoxNzcwOTgwMjIxLjMxNDkzOSwiZXhwIjoxODAyNTE2MjIxLjMwOTIzOSwic3ViIjoiMTkiLCJzY29wZXMiOlsiKiJdfQ.ftCrIpw4LsnjUzpDWzciH0h_jJjJoLbGpqeoOrFSrrg3ldAR1vGTP50rwvENLmcflo_G9Woo4yC4gHQ42FY0jbIx9WUcn9p0BPxCqmQLkHHjL3E0__Ddr28_9RWiMC24ybrHgqLeJSvsmHKLLt1Cqv_zNJddS4JgnO0PcRPVeML9Xb0m3AD-Hq0RH4T9cGDLiERABAjR-5ANy2Iu8ESafBGzudp8tw3Ad2sBNLUsZTRRZ_PLOab_-RgPID2VbDicFWRuOlvYDNiYlplDSJTeTeW6wjmwOYel5j-AK53QKtr99iYzKDqqaV4hU3yz-YefLLCtIkP0UBJMgiGirohCHzTCEsFdCDwpyXstT2tR6ePpdpOyHgcE0Z6pocgoY4z9U0Tic1jqE7E5DxBL37rcMABItZMtsAc7pDiJ_6tcDMLPHu4IVVtaUn-Erckf5HKw2kFEGxjye1DbwHEowothntcOTWX2RUaN5Sd-5nJuG2oyQUyfP-kAkSW4rytJ_h8o1cXQGhJt22sg3kAe1-o26ZU74XYF_n7NQ3PQ-91IIEXoAES_-RGM6e4lu7-BWS76nYDuL1hSvsBvcgTjUcEDIHbtstHGrWL8ihMaKAB3RknHHNjmUtnu-tjv-Ce3q7posCbz67XdulWuCTQXayw8DoefkY7sIjiNcIKNzdwNFns"
      },
      data: JSON.stringify({
        cid: workoutConfig?.cid,
        sig: workoutConfig?.sig
      }),
    };
    function initSlider(selector) {
        $(selector).slick({
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3 } },
                { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } }
            ],
            customPaging: function(slider, i) {
                // 'i' è l'indice della slide corrente
                // Recuperiamo il valore dal data-attribute del div che abbiamo appena appeso
                var scadenzaLabel = $(slider.$slides[i]).data('creation-date');
                
                // Ritorniamo il contenuto che vogliamo dentro il <li> del dot
                return '<button class="custom-dot"></button>';
            }
        });
    }
    $.ajax(settings)
      .done(function (response,status,xhr) {
        if ( xhr.status == 200 ) {
          const hasOneShot = response.one_shot && response.one_shot.length > 0;
          const hasSubscription = response.subscription && response.subscription.length > 0;

          if (!hasOneShot && !hasSubscription) {
            $(".tp-trigger").before(alertTemplate());
          }else{
            if(response.subscription.length > 0) {
              $("#subscription").show();
              $.each(response.subscription, function(index, item) {
                if (item.date_start != null && item.plan_status != false) {
                  var creationDate = item.date_start;  //2026-01-13T10:41:29.000000Z 
                  var dateSplit = creationDate.split('-');
                  if( getRemainingDays(creationDate)!= 'Scaduto' ) {
                    subscriptionEl.find(".wrapper").append(
                      '<div class="bff-subscription-container bff-overlay gradient-b-w mb-30 program-item" style="background-image: url('+item.plan_type_image_url+'); height: 320px; width: 100%; max-width: 420px; margin: 0 auto;" data-creation-date="'+item.shopify_order_id+'">'+
                          '<div class="bff-tp-detail-head"><span class="bff-order-no" style="float: left;"> Ordine #'+item.shopify_order_id+'</span><span class="d-block" style="color: white; float: right; font-size: 12px; text-transform: uppercase; font-weight: 700; margin: 5px 0;">'+dateNormalize(dateSplit[1],dateSplit[0])+'</span></div>'+
                          '<h2>'+item.plan_type_name+'<br/><small>'+item.diet+'</small></h2>'+
                          '<div class="action-box"><a href="https://befancyfit.com/pages/the-program?id='+item.plan_id+'&o='+item.shopify_order_id+'&d='+dateNormalize(dateSplit[1],dateSplit[0])+'&t='+item.plan_type_name+'&e='+item.eating_plan_id+'" class="bff-btn bff-btn-black bff-btn-sm radius"><span class="text-center">VISUALIZZA PROGRAMMA</span></a><small class="d-block">'+getRemainingDays(creationDate)+'</small></div>'+
                      '</div>'
                    );  
                  }              
                }else{
                  subscriptionEl.find(".wrapper").append(
                      '<div class="bff-subscription-container bff-overlay gradient-b-w mb-30" style="background: #000; height: 320px; width: 100%; max-width: 420px; margin: 0 auto;" data-creation-date="'+item.shopify_order_id+'">'+
                        '<div class="bff-tp-detail-head"><span class="bff-order-no" style="float: left;"> Ordine #'+item.shopify_order_id+'</span></div>'+
                        manageProblems(item.customer_tags || "")+
                      '</div>'
                  );  
                }
              });
              initSlider(subscriptionEl.find(".wrapper"));
            }else{
              subscriptionEl.remove();
            }
            //Sub
            if(response.one_shot.length > 0) {
              $("#oneshot").show();
              $.each(response.one_shot, function(index, item) {
                if (item.date_start != null & item.plan_status != false ) {
                  var creationDate = item.date_start;  //2026-01-13T10:41:29.000000Z 
                  var dateSplit = creationDate.split('-');
                   if( getRemainingDays(creationDate)!= 'Scaduto' ) {
                    oneshotEl.find(".wrapper").append(
                      '<div class="bff-subscription-container bff-overlay gradient-b-w mb-30 program-item" style="background-image: url('+item.plan_type_image_url+'); height: 320px; width: 100%; max-width: 420px; margin: 0 auto;" data-creation-date="'+item.shopify_order_id+'">'+
                          '<div class="bff-tp-detail-head"><span class="bff-order-no" style="float: left;"> Ordine #'+item.shopify_order_id+'</span><span class="d-block" style="color: white; float: right; font-size: 12px; text-transform: uppercase; font-weight: 700; margin: 5px 0;">'+dateNormalize(dateSplit[1],dateSplit[0])+'</span></div>'+
                          '<h2>'+item.plan_type_name+'<br/><small>'+item.diet+'</small></h2>'+
                          '<div class="action-box"><a href="https://befancyfit.com/pages/the-program?id='+item.plan_id+'&o='+item.shopify_order_id+'&d='+dateNormalize(dateSplit[1],dateSplit[0])+'&t='+item.plan_type_name+'&e='+item.eating_plan_id+'" class="bff-btn bff-btn-black bff-btn-sm radius"><span class="text-center">VISUALIZZA PROGRAMMA</span></a><small class="d-block">'+getRemainingDays(creationDate)+'</small></div>'+
                      '</div>'
                    );
                   }
                }else{
                  oneshotEl.find(".wrapper").append(
                      '<div class="bff-subscription-container bff-overlay gradient-b-w mb-30" style="background: #000; height: 320px; width: 100%; max-width: 420px; margin: 0 auto;" data-creation-date="'+item.shopify_order_id+'">'+
                        '<div class="bff-tp-detail-head"><span class="bff-order-no" style="float: left;"> Ordine #'+item.shopify_order_id+'</span></div>'+
                        manageProblems(item.customer_tags || "")+
                      '</div>'
                  );  
                }
              });
              initSlider(oneshotEl.find(".wrapper"));
            }else{
              oneshotEl.remove();
            }
          }
        }else{
          $(".tp-trigger").before(alertTemplate());
        }
      })
      .fail(function(){
        subscriptionEl.remove();
        oneshotEl.remove();
        $("#theprogram-listing").append("<p class='text-center'><strong>Errore di connessione</strong></p>");
      });
  }
  function dateNormalize(monthNumber, year) {
      const months = [
          "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
          "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
      ];
      var monthName = months[Number(monthNumber) - 1];
      if (!monthName) return "Mese non valido";
      return monthName + " " + year;
  }
  function getRemainingDays(creationDate) {
      const TOTAL_DURATION = 90;
      const start = new Date(creationDate);
      const today = new Date();
      const diffInMs = today - start;
      const daysPassed = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
      const daysRemaining = TOTAL_DURATION - daysPassed;

      // Gestione del testo in base ai giorni rimasti
      if (daysRemaining <= 0) {
          return "Scaduto";
      } else {
          return "Visibile ancora per " + daysRemaining + " giorni";
      }
  }
  function manageProblems(theproblem){
      var theMessage;
      switch(true) {
      case theproblem.indexOf("account-noncompilato") != -1:
          theMessage =    '<div class="problem-message">'+
                          '<p class="d-block mb-10">'+
                              'Il tuo account risulta non compilato, l\'inserimento dei dati è fondamentale per poter personalizzare e visualizzare il tuo The Program. Ti preghiamo di inserire tutte le informazioni del form presenti nel tuo account e di inviare conferma all\'indirizzo email: info@befancyfit.com.'+
                          '</p>'+
                          '<a href="https://befancyfit.com/account?view=edit" class="bff-btn bff-btn-black bff-btn-xs radius">'+
                              '<span>inserisci i dati mancanti</span>'+
                          '</a></div>'
          break;
      case theproblem.indexOf("sonodachiamare")!= -1:
          theMessage =    '<div class="problem-message">'+
                          '<p class="d-block mb-10">'+
                              'Visualizzi questo messaggio perché hai segnalato nel form, durante la compilazione del tuo account, di avere problemi da segnalare.'+
                              '<ol>'+
                                  '<li>'+
                                      '<p><strong>Hai già segnalato i problemi al customer care?</strong> Il tuo The Program è in fase di personalizzazione, riceverai una email quando sarà pronto</p>'+
                                  '</li>'+
                                  '<li>'+
                                      '<p><strong>Non hai segnalato i problemi al customer care?</strong> invia una email all\'indirizzo info@befancyfit.com inserendo nell\'oggetto "problemi da segnalare [numero ordine]" e nel corpo della mail le informazioni in merito alla tua problematica. Questo ci aiuterà a personalizzare ulteriormente il tuo programma.</p>'+
                                  '</li>'+
                                  '<li>'+
                                      '<p><strong> Il tuo problema è ormai risolto?</strong> se il tuo problema è ormai risolto, ti invitiamo a scrivere all\'indirizzo email info@befancyfit.com</p>'+
                                  '</li>'+
                              '</ol>'+
                          '</p>'
          break;
      // case "intolleranze":
      //     theMessage =    '<div class="problem-message">'+
      //                     '<p class="d-block mb-10">'+
      //                         'Visualizzi questo messaggio perché hai segnalato nel form, durante la compilazione del tuo account, di avere intolleranze o allergie alimentari.'+
      //                         '<ol>'+
      //                             '<li>'+
      //                                 '<p><strong>Hai già segnalato i problemi al customer care?</strong> Il tuo The Program è in fase di personalizzazione, riceverai una email quando sarà pronto</p>'+
      //                             '</li>'+
      //                             '<li>'+
      //                                 '<p><strong>Non hai segnalato i problemi al customer care?</strong> invia una email all\'indirizzo info@befancyfit.com inserendo nell\'oggetto "intolleranze [numero ordine]" e nel corpo della mail la dieta che il tuo medico ti ha prescritto. Questo ci aiuterà a personalizzare ulteriormente il tuo programma.</p>'+
      //                             '</li>'+
      //                         '</ol>'+
      //                     '</p>'
      //     break;
      }  
      return theMessage;      
  }
  function alertTemplate(){
    const template =  '<div class="bg-black" style="padding: 20px 15px; margin-bottom: 20px; border-radius: 10px;">'+
                        '<div class="bff-container">'+
                          '<h4>Are you ready?</h4>'+
                          '<p>Non hai al momento nessun THE PROGRAM acquistato, troverai qui i programmi acquistati.</p>'+
                          '<h4>Non sai quale The Program scegliere?</h4>'+
                          '<p>Scopri quale tra i The Program è più adatto alle tue esigenze</p>'+
                          '<a href="https://befancyfit.com/#quiz-6OHzQb?profile" class="bff-btn bff-btn-white bff-btn-sm bff-btn-fullw radius" style="padding: 12px 20px;">FAI IL TEST</a>'+
                        '<div>'+
                      '<div>';
    return template;
  }
}

  